import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { HttpApiService } from '@recruitee/http';
import { DeletionRequest } from '@recruitee/http-types';

@Injectable({ providedIn: 'root' })
export class CompanyDeletionRequestHttpClient {
  constructor(private httpApi: HttpApiService) {}

  public fetch(): Observable<DeletionRequest> {
    return this.httpApi.get('/deletion_requests/pending').pipe(map(data => data.deletionRequest));
  }

  public createDeletionRequest(secureChangeToken: string): Observable<void> {
    return this.httpApi.post('/deletion_requests', {}, { secureChangeToken });
  }
}
